import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { history, useIntl } from 'umi';
import { Table } from 'tea-component';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Stats.scss';
import Sortstable from '@/pages/intelligence/components/TableComponents/Sortstable';
import { formatNum, formatPercentNum } from '@/pages/intelligence/utils/commonUtils';
import '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/index.scss';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import SortBy from '@/pages/intelligence/components/TableComponents/components/SortBy';
import AppAnnie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import { DataSourceBubbleContent } from '@/pages/intelligence/components/DataSourceBubbleContent';
import mscience32 from '@/pages/intelligence/assets/svg/marketprofile/mscience32.svg';
import npd from '@/pages/intelligence/assets/svg/dataSource/npd.svg';
const { scrollable, pageable } = Table.addons;

export default function OperationTable(props: any) {
  const {
    showTableData,
    changeTableSort,
    sortColunms,
    gameType,
    onPagingChange,
    dataType,
    tableLength,
    pageSize,
    pageIndex,
  } = props;
  const { formatMessage } = useIntl();

  const tableColumns = [
    {
      key: 'date_stats',
      align: 'left',
      header: (
        <SortBy
          type="font_sort"
          className={'dbi-table-header-flex-left'}
          title={formatMessage({ id: 'dbi_date' })}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          list={[
            {
              key: `date`,
              text: formatMessage({ id: 'dbi_date' }),
              title: formatMessage({ id: 'dbi_date' }),
            },
          ]}
        />
      ),
      render: (cvm: any) => cvm.date,
    },
    {
      key: 'revenue',
      align: 'right',
      header: (
        <SortBy
          type="font_sort"
          title={
            gameType == 'mobile'
              ? formatMessage({ id: 'dbi_total_rev_$' })
              : formatMessage({ id: 'dbi_metric_digitalRevenue' })
          }
          svgIcon={gameType == 'mobile' ? AppAnnie : mscience32}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={
                gameType == 'mobile'
                  ? formatMessage({ id: 'dbi_total_rev_$' })
                  : formatMessage({ id: 'dbi_metric_digitalRevenue' })
              }
              metric={gameType == 'mobile' ? 'appannie' : 'mscience'}
              metricKey={gameType == 'mobile' ? 'revenue' : 'digitalRevenue'}
              entityType={gameType}
            />
          }
          content={
            gameType == 'mobile' ? (
              <div style={{ maxWidth: '418px' }}>
                {formatMessage({ id: 'dbi_info_sum_selected' })}
                <br />
                {formatMessage({ id: 'dbi_info_revenue_removed' })}
                <br />
                {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
              </div>
            ) : (
              formatMessage({ id: 'dbi_info_sum_selected' })
            )
          }
          list={[
            {
              key: `revenue`,
              text: formatMessage({ id: 'dbi_revenue_$' }),
              title:
                gameType == 'mobile'
                  ? formatMessage({ id: 'dbi_total_rev_$' })
                  : formatMessage({ id: 'dbi_metric_digitalRevenue' }),
            },
            {
              key: `revenueChange`,
              text: `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                id: 'dbi_change',
              })}(%)`,
              title:
                gameType == 'mobile'
                  ? `${formatMessage({ id: 'dbi_total_rev_$' })}%`
                  : `${formatMessage({ id: 'dbi_metric_digitalRevenue' })}%`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={
            cvm[gameType == 'mobile' ? 'revenue' : 'revenueDigital'] == 0
              ? '-'
              : formatNum(cvm[gameType == 'mobile' ? 'revenue' : 'revenueDigital'], true)
          }
          type={
            cvm[gameType == 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] > 0
              ? 'up'
              : cvm[gameType == 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] < 0
              ? 'down'
              : ''
          }
          growth={
            cvm[gameType == 'mobile' ? 'revenueChange' : 'revenueDigitalChange'] == 0
              ? '-'
              : formatPercentNum(
                  cvm[gameType == 'mobile' ? 'revenueChange' : 'revenueDigitalChange'],
                )
          }
        />
      ),
    },
    {
      key: 'download',
      align: 'right',
      header: (
        <SortBy
          type="font_sort"
          title={
            gameType == 'mobile'
              ? formatMessage({ id: 'dbi_downloads' })
              : formatMessage({ id: 'dbi_metric_physical_revenue' })
          }
          svgIcon={gameType == 'mobile' ? AppAnnie : npd}
          filter={changeTableSort}
          defaultKey={sortColunms[0]}
          defaultValue={'desc'}
          svgTip={
            <DataSourceBubbleContent
              sourceNameLocalId={
                gameType == 'mobile'
                  ? formatMessage({ id: 'dbi_downloads' })
                  : formatMessage({ id: 'dbi_metric_physical_revenue' })
              }
              metric={gameType == 'mobile' ? 'appannie' : 'npd'}
              metricKey={gameType == 'mobile' ? 'download' : 'physical_revenue'}
              entityType={gameType}
            />
          }
          content={
            gameType === 'mobile' ? (
              <>
                {formatMessage({ id: 'dbi_info_sum_selected' })}
                <br />
                {formatMessage({ id: 'dbi_info_mobile_datasource_range' })}
              </>
            ) : (
              <>{formatMessage({ id: 'dbi_info_sum_selected' })}</>
            )
          }
          list={[
            {
              key: `downloads`,
              text:
                gameType == 'mobile'
                  ? formatMessage({ id: 'dbi_downloads' })
                  : formatMessage({ id: 'dbi_revenue_$' }),
              title:
                gameType == 'mobile'
                  ? formatMessage({ id: 'dbi_downloads' })
                  : formatMessage({ id: 'dbi_metric_physical_revenue' }),
            },
            {
              key: `downloadsChange`,
              text:
                gameType == 'mobile'
                  ? `${formatMessage({ id: 'dbi_downloads' })}:${formatMessage({
                      id: 'dbi_change',
                    })}(%)`
                  : `${formatMessage({ id: 'dbi_revenue_$' })}:${formatMessage({
                      id: 'dbi_change',
                    })}(%)`,
              title:
                gameType == 'mobile'
                  ? `${formatMessage({ id: 'dbi_downloads' })}(%)`
                  : `${formatMessage({ id: 'dbi_metric_physical_revenue' })}(%)`,
            },
          ]}
        />
      ),
      render: (cvm: any) => (
        <TableShowData
          value={
            cvm[gameType == 'mobile' ? 'download' : 'revenuePhysical'] == 0
              ? '-'
              : formatNum(cvm[gameType == 'mobile' ? 'download' : 'revenuePhysical'], true)
          }
          type={
            cvm[gameType == 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'] > 0
              ? 'up'
              : cvm[gameType == 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'] < 0
              ? 'down'
              : ''
          }
          growth={
            cvm[gameType == 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'] == 0
              ? '-'
              : formatPercentNum(
                  cvm[gameType == 'mobile' ? 'downloadChange' : 'revenuePhysicalChange'],
                )
          }
        />
      ),
    },
  ];

  return (
    <Sortstable
      recordKey={'date'}
      tableData={{
        cvmList: showTableData,
        addons: [
          scrollable({
            minWidth: 1800,
          }),
          pageable({
            recordCount: dataType == 'game' ? tableLength : showTableData?.length || 0,
            isPagingReset: true,
            stateText: `Total items: ${
              dataType == 'game' ? tableLength : showTableData?.length || 0
            }`,
            pageSizeOptions: dataType == 'operation' ? [5, 10, 20] : [10, 20, 50],
            // pageCountChangingResetType: 'last',
            pageSize,
            pageIndex,
            onPagingChange,
          }),
        ],
        columns: tableColumns,
      }}
    />
  );
}
